module.exports = __webpack_public_path__ + "img/enemy_122_002.ba1920ef.png";